import { Component } from '@opten/gin-tonic/helpers/compiler';

@Component({ className: 'js-sidebar' })
export class SidebarComponent {
	private item;
	private itemSelector = '.js-sidebar-item';
	private toggleSelector = '.js-sidebar-toggle';
	private expandedClass = 'singha-sidebar-expanded';
	private collapsedClass = 'singha-sidebar-collapsed';

	constructor(private element: HTMLElement) {
		this.item = this.element.querySelector<HTMLElement>(this.itemSelector);
		this.element
			.querySelector(this.toggleSelector)
			?.addEventListener('click', this.handleClick.bind(this));
	}

	handleClick() {
		const list = this.item?.classList;
		const isExpanded = list.contains(this.expandedClass);
		list.toggle(this.expandedClass, !isExpanded);
		list.toggle(this.collapsedClass, isExpanded);
	}
}
